//import config from "config";
import authHeader from "../helpers/authHeader";
import history from "../helpers/history";
import alertActions from "../actions/alertActions";

const login = (username, password) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/Login`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      sessionStorage.setItem("user", JSON.stringify(user));
      alertActions.success("Successfully logged in.")
      return user;
    });
};

const updateLogin = async (userValues) => {
  const user = {
    ...JSON.parse(sessionStorage.getItem("user")),
    firstName: userValues.firstName,
    lastName: userValues.lastName,
    userName: userValues.userName,
    dob: userValues.dob,
  };
  //console.log(user);
  sessionStorage.setItem("user", JSON.stringify(user));
  return user;
};

const register = (
  dob,
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  phoneNumber
) => {
  //console.log(dob, firstName, lastName, email, password, confirmPassword);
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/Register`,
    {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        dob,
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        phoneNumber,
      }),
    }
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      sessionStorage.setItem("user", JSON.stringify(user));

      return user;
    });
};

const resetPasswordRequest = (resetRequest) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(resetRequest),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/RequestResetPassword`,
    requestOptions
  );
};

const resetPassword = (newPassword) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(newPassword),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/ResetPassword`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const logoutServer = async () => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/Logout`,
    requestOptions
  );
};

const logout = () => {
  // remove user from local storage to log user out
  if (sessionStorage.getItem("user")) {
    logoutServer().then(() => {
      sessionStorage.clear();
      history.go(0);
    });
  }
};

const verifyStaff = async () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/VerifyStaff`,
    requestOptions
  );
};

const verifyAttorney = async () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/VerifyAttorney`,
    requestOptions
  );
};

const confirmEmail = (emailConfirmation) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(emailConfirmation),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/ConfirmEmail`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      setInterval(() => {
        history.push("/");
      }, 5000);
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
      }
      if (response.status === 400) {
      }
      //console.log(data);
      const error =
        response.status === 400
          ? data.map((a) => a.description)
          : (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const refreshToken = () => {
  let user = JSON.parse(sessionStorage.getItem("user"));
  if(user !== null) {
    const tokenModel = { accessToken: user.token, refreshToken: user.refreshToken}
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(tokenModel),
    };
    //console.log("login request");
    return fetch(
      `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/refreshToken`,
      requestOptions
    )
      .then(handleResponse)
      .then((user) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        sessionStorage.setItem("user", JSON.stringify(user));
        alertActions.success("Successfully refreshed token." + user)
        return;
      });
  }
};

const userService = {
  login,
  logout,
  register,
  updateLogin,
  verifyStaff,
  verifyAttorney,
  resetPassword,
  resetPasswordRequest,
  confirmEmail,
  refreshToken
};

export default userService;
